import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plane, Loader2, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen navy-panel flex items-center justify-center px-4">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" data-testid="login-logo" className="inline-flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <Plane className="w-5 h-5 text-[#F59E0B]" />
            </span>
            <span className="font-display font-bold text-2xl tracking-wide text-white uppercase">Cabin Crew <span className="text-sky-400">Admin</span></span>
          </Link>
        </div>
        <form onSubmit={handleSubmit} className="rounded-2xl bg-white p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-sky-700">
            <Lock className="w-3.5 h-3.5" /> Crew only
          </div>
          <h1 className="text-2xl font-bold text-[#0A192F] mt-2">Admin sign in</h1>
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="admin-email">Email</Label>
              <Input id="admin-email" data-testid="admin-email-input" type="email" className="mt-2" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="admin-password">Password</Label>
              <Input id="admin-password" data-testid="admin-password-input" type="password" className="mt-2" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <div data-testid="admin-login-error" className="rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3">{error}</div>}
            <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-[#0A192F] hover:bg-sky-800 py-6 font-bold">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
            </Button>
          </div>
        </form>
        <p className="text-center mt-6">
          <Link to="/" data-testid="login-back-link" className="text-slate-400 text-sm hover:text-white transition-colors duration-200">Back to site</Link>
        </p>
      </motion.div>
    </div>
  );
}
